import { render, staticRenderFns } from "./KozHubVideosAddVideo.vue?vue&type=template&id=1ee8e37c&"
import script from "./KozHubVideosAddVideo.vue?vue&type=script&lang=js&"
export * from "./KozHubVideosAddVideo.vue?vue&type=script&lang=js&"
import style0 from "./KozHubVideosAddVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports